import { TrackerStatus } from './tracker.types';

export const TRACKER_STATUS_MESSAGE: Record<TrackerStatus, string> = {
  finished: 'Concluído',
  inprogress: 'Em andamento',
  waiting: 'Em espera',
  error: 'Não realizado',
  alert: 'Atenção',
  disabled: '',
};
